import { useQuery } from "@tanstack/react-query";
import { useTacticHooks } from "../../providers/TacticHooksProvider";

/** React Query key for the desk dedicated to a user. */
export const dedicatedResourceOfQueryKey = (userId: string | undefined) =>
  ["users.dedicatedResource", userId] as const;

/**
 * The desk dedicated to a user, if any: the first of the user's
 * `dedicated_resources`, which a person has at most one of.
 */
export const useDedicatedResourceOf = (userId: string | undefined) => {
  const { apiClient } = useTacticHooks();
  return useQuery({
    queryKey: dedicatedResourceOfQueryKey(userId),
    queryFn: async () => {
      if (!userId) return null;
      const users = await apiClient.organizations.usersById([userId]);
      return users[0]?.dedicated_resources?.[0] ?? null;
    },
    enabled: !!userId
  });
};
